export default "__VITE_ASSET__BoWFRjv4__"